import IconSvg from "../IconSvg/IconSvg";
import {readMarkNotiAll} from "../../network/notiApi";
import {fetchCountNoti, fetchNotification} from "../../services/notiServices";
import React from "react";
import popupStore from "../../store/popupStore";
import {VARIANT} from "../../constants";
import Button from "../Common/Button";

const PopupReadNoti = () => {
    const {setPopupMobile} = popupStore() || {}
    const handleConfirm = () => {
        readMarkNotiAll().then(res => {
            if (res.success) {
                fetchNotification({
                    page: 1,
                    size: 5,
                    type: 'seller_order'
                })
                fetchCountNoti({
                    type: 'seller_order'
                })
                setPopupMobile({})
            }
        })
    }

    return (
        <div className="flex flex-col gap-1.5 items-start pt-10 px-4">
            <div className="flex items-center p-2.5 gap-2.5">
                <IconSvg color="#111827" iconName="mark-1" size={24}/>
                <div className='text-sm text-black'>Đánh dấu đã đọc tất cả tin nhắn</div>
            </div>
            <div className="w-full flex  flex-col justify-center items-center text-center space-y-4">
                <Button className='w-full' variant={VARIANT.PRIMARY} onClick={handleConfirm}>
                    Đồng ý
                </Button>
                <Button
                    className='!w-fit bg-transparent text-[#197D55] underline hover:border-none text-sm'
                    onClick={() => setPopupMobile({})}>
                    Bỏ qua
                </Button>
            </div>
        </div>
    )
}
export default PopupReadNoti;